
export class GlobalVariables {
    public static minPasswordLength: number = 8;
    public static toastTimer: number = 3000;

    /* ####################### URL #######################*/
    //local
    // public static sabsWebsiteFEUrl: string = 'http://localhost:4200';

    //Staging URL
    // public static sabsWebsiteFEUrl: string = 'https://sabs-website-fe.web.app';

    //Temporary Live URL
    // public static sabsWebsiteFEUrl: string = 'https://website.sabs.org.my';

    // Live URL
    public static sabsWebsiteFEUrl: string = 'https://sabs.org.my';
    
    /* ####################### URL #######################*/
    
    //Shorten URL
    public static sabsWebsiteFEShortenUrl: string = this.sabsWebsiteFEUrl+'/s/';
}




